const ShowHideComponent = props => {
  return props.show ? props.children : null;
};

export default ShowHideComponent;
